module.exports = __webpack_public_path__ + "media/npc_dota_hero_spirit_breaker.eb52c43b.webm";